export const PatientIndicator = {
  UPDATED: "À jour",
  OUTDATED: "En retard"
};

export const getPatientIndicatorOptions = () => {
  return [
    { value: "", label: "Tous les statuts" },
    { value: "true", label: "À jour" },
    { value: "false", label: "En retard" },
  ];
};